var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6875 10.3125C18.0938 10.6875 18.0938 11.3438 17.6875 11.7188L12.6875 16.7188C12.0625 17.3438 11 16.9062 11 16V13.7812C7.1875 13.9375 6.34375 14.6875 7.1875 17.75C7.46875 18.6562 6.40625 19.375 5.65625 18.8125C4.03125 17.6562 3 15.9688 3 13.9375C3 9.15625 7.375 8.40625 11 8.28125V6.03125C11 5.125 12.0625 4.6875 12.6875 5.3125L17.6875 10.3125ZM12 16.0312L17 11.0312L12 6.03125V9.28125C7.90625 9.3125 4 9.84375 4 13.9375C4 15.9688 5.25 17.2812 6.25 18.0312C4.96875 13.4688 7.4375 12.8125 12 12.7812V16.0312ZM20.6875 11.7188L15.6875 16.7188C15.2812 17.1562 14.6562 17.0938 14.2812 16.7188L20 11.0312L14.2812 5.3125C14.6562 4.9375 15.2812 4.875 15.6875 5.3125L20.6875 10.3125C21.0938 10.6875 21.0938 11.3438 20.6875 11.7188Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceAccess);
export default __webpack_public_path__ + "static/media/service-access.24ac4375.svg";
export { ForwardRef as ReactComponent };